// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--954ee";
export var footerNoNav = "footer-module--footer--no-nav--22d82";
export var footer__accordion__iconCollapsed = "footer-module--footer__accordion__icon-collapsed--54dc7";
export var footer__accordion__iconExpanded = "footer-module--footer__accordion__icon-expanded--b0d31";
export var footer__accordion__item = "footer-module--footer__accordion__item--596e7";
export var footer__accordion__itemOpened = "footer-module--footer__accordion__item--opened--0922d";
export var footer__accordion__title = "footer-module--footer__accordion__title--c9b0c";
export var footer__accordion__titleClosed = "footer-module--footer__accordion__title--closed--06d93";
export var footer__accordion__titleOpened = "footer-module--footer__accordion__title--opened--55afc";
export var footer__footnote = "footer-module--footer__footnote--68844";
export var footer__footnoteLeft = "footer-module--footer__footnote-left--96837";
export var footer__footnoteRight = "footer-module--footer__footnote-right--99ca0";
export var footer__footnote__link = "footer-module--footer__footnote__link--71461";
export var footer__footnote__text = "footer-module--footer__footnote__text--5d494";
export var footer__layout = "footer-module--footer__layout--8dbe9";
export var footer__logo = "footer-module--footer__logo--ff682";
export var footer__logoWrapper = "footer-module--footer__logo-wrapper--36533";
export var footer__menuGroup = "footer-module--footer__menu-group--f3d53";
export var footer__menuGroupDesktop = "footer-module--footer__menu-group--desktop--4ab9e";
export var footer__menuGroup__li = "footer-module--footer__menu-group__li--27870";
export var footer__menuGroup__link = "footer-module--footer__menu-group__link--72c9b";
export var footer__menuGroup__title = "footer-module--footer__menu-group__title--46ca3";
export var footer__menuGroup__ul = "footer-module--footer__menu-group__ul--3d92e";
export var footer__mobileNav = "footer-module--footer__mobile-nav--5e335";
export var grid = "footer-module--grid--ac26d";
export var gridWithRowGap = "footer-module--grid--with-row-gap--78393";
export var maxWidthContainer = "footer-module--max-width-container--a1f52";
export var mt0 = "footer-module--mt-0--74316";
export var mt1 = "footer-module--mt-1--5ab43";
export var mt2 = "footer-module--mt-2--774de";
export var mt3 = "footer-module--mt-3--dab09";
export var mt4 = "footer-module--mt-4--d088d";
export var mt5 = "footer-module--mt-5--572e0";
export var mt6 = "footer-module--mt-6--7879e";
export var removeVisuallyHidden = "footer-module--remove-visually-hidden--c587b";
export var visuallyHidden = "footer-module--visually-hidden--718a6";
export var widgetBase = "footer-module--widget-base--d4ee6";